exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".linkButtonContainer__3d49j{cursor:pointer;background-color:transparent;border:none;padding:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#666}.left__2b3kL{margin-right:.5rem}", "", {"version":3,"sources":["/opt/build/repo/src/components/LinkButton/LinkButton.styles.scss"],"names":[],"mappings":"AAEA,4BACE,eACA,6BACA,YACA,UACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,UAAW,CACZ,aAGC,kBAAmB,CACpB","file":"LinkButton.styles.scss","sourcesContent":["@import '../../variables';\n\n.linkButtonContainer {\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  color: #666;\n}\n\n.left {\n  margin-right: .5rem;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"linkButtonContainer": "linkButtonContainer__3d49j",
	"left": "left__2b3kL"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/LinkButton/LinkButton.styles.scss
// module id = p0cL
// module chunks = 0